export default __webpack_public_path__ + "static/frag-d87cee3704f1438840bb2ce81b9ab3f0.png";